import { StatusAvaliacao } from "./avaliacoes";

export enum StatusProduto {
  ATIVO = "ATIVO",
  INATIVO = "INATIVO",
  ARQUIVADO = "ARQUIVADO",
}
export interface IProdutoLoja {
  id?: string;
  nome: string;
  slug: string;
  descricao: string;
  emPromocao: boolean;
  emDestaque: boolean;
  status: StatusProduto.ATIVO | StatusProduto.INATIVO | StatusProduto.ARQUIVADO;
  pesoKg: number;
  larguraCm: number;
  alturaCm: number;
  comprimentoCm: number;
  digital: boolean;
  urlDownload: any;
  eventoId: number | null;
  evento?: { id: number; titulo: string; slug: string; dataEvento?: string; nomeDoLocal?: string } | null;
  freteGratis?: boolean;
  retiradaNoLocal?: boolean;
  marcaId?: number | null;
  marca?: { id: number; nome: string; slug: string } | null;
  mediaAvaliacoes: number;
  qtdAvaliacoes: number;
  createAt: string;
  updatedAt: string;
  imagens: IImagemProduto[];
  especificacoes: IEspecificacaoProduto[];
  tabelasTamanho: ITabelaTamanho[];
  variacoes: IVariacaoProduto[];
  categorias: ICategoriaProduto[];
  avaliacoes: IAvaliacaoProduto[];
}

export type TStatusProduto = "ATIVO" | "INATIVO" | "ARQUIVADO";

export interface IProdutoLojaCreate {
  id?: string;
  nome: string;
  descricao: string;
  status: TStatusProduto;
  emPromocao: boolean;
  emDestaque: boolean;
  pesoKg: number;
  larguraCm: number;
  alturaCm: number;
  comprimentoCm: number;
  digital: boolean;
  urlDownload?: string | null;
  eventoId?: number | null;
  freteGratis?: boolean;
  retiradaNoLocal?: boolean;
  marcaId?: number | null;
  preco: number;
  precoOriginal?: number | null;
  estoquePadrao: number;
  emEstoque: boolean;
}

interface IAvaliacaoProduto {
  id: string;
  status: StatusAvaliacao;
  nota: number;
  titulo: string;
  votosUteis: number;
  comentario: string;
  createAt: string;
}

interface ICategoriaProduto {
  id: number;
  nome: string;
  slug: string;
  descricao?: string | null;
}

export interface IImagemProduto {
  url: string;
  produtoId?: string | null;
  variacaoProdutoId?: string | null;
  textoAlternativo?: string | null;
  ordem?: number;
}

export interface IEspecificacaoProduto {
  id?: number;
  chave: string;
  valor: string;
  ordem?: number;
}

interface ITabelaTamanhoLinha {
  id?: number;
  campo: string;
  valor: string;
  ordem?: number;
}

export interface ITabelaTamanho {
  id?: number;
  titulo: string;
  linhas?: ITabelaTamanhoLinha[];
}

interface IAtributos {
  id?: string;
  atributo: { id: number; nome: string; slug: string };
  opcao?: { id: number; label: string; valor: string; ordem: number } | null;
  valorTexto?: string | null;
  valorNumero?: number | null;
  valorBoolean?: boolean | null;
  valorCor?: string | null;
}

export interface IVariacaoProduto {
  id?: string;
  sku: string;
  estoque?: number;
  preco?: number | null;
  precoOriginal?: number | null;
  precoCusto?: number | null;
  emEstoque?: boolean;
  codigoBarras?: string | null;
  isPadrao?: boolean;
  atributos?: IAtributos[];
}
